import { render } from "./RoomDetailsView.vue?vue&type=template&id=116fea1a"
import script from "./RoomDetailsView.vue?vue&type=script&lang=js"
export * from "./RoomDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__